<template>

</template>

<script>
export default {
  name: "Punishment"
}
</script>

<style scoped>

</style>